import { render } from "./Dashboard.vue?vue&type=template&id=105eccc6"
import script from "./scripts/dashboard.ts?vue&type=script&language=ts&lang=js"
export * from "./scripts/dashboard.ts?vue&type=script&language=ts&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__